/* import __COLOCATED_TEMPLATE__ from './network-quality-indicator-inline.hbs'; */
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class TwilioNetworkQualityIndicatorInline extends Component {
  @service session;

  get featureThPreflightApi() {
    return this.session.roomModel.featureThPreflightApi;
  }
}
